import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { IconLogo, IconPhone, IconHeadPhone, IconMenuFold } from '../../constants/icons'
import { VNTRIP_INFO } from '../../constants/common'
import { useDispatch } from 'react-redux'
import { toggleSidebarMobile } from '../../redux/actions/common-action'
import { toggleClassNoScroll } from '../../func/common'
import HeaderNav from './HeaderNav'
interface Props {}
const Header: React.FC<Props> = () => {
    const dispatch = useDispatch()
    const openSidebar = () => {
        toggleClassNoScroll('add')
        dispatch(toggleSidebarMobile(true))
    }
    const { pathname } = useLocation()
    return (
        <div className="header">
            <div className="header__desktop">
                <div className="header__content header__top">
                    <div className="container flex-group">
                        <div className="header__logo">
                            <Link className="logo" to={'/'}>
                                <IconLogo />
                            </Link>
                        </div>
                        <div className="header__hotline d-flex">
                            <IconHeadPhone />
                            <a href={`tel:${VNTRIP_INFO.hotline}`} className="margin-left-5">
                                {VNTRIP_INFO.hotline}
                            </a>
                        </div>
                    </div>
                </div>
                {pathname === '/' && <HeaderNav />}
            </div>
            <div className="header__mobile">
                <div className="container flex-group">
                    <div className="flexGroup">
                        <button type="button" className="btnToggle" onClick={openSidebar}>
                            <IconMenuFold />
                        </button>
                        {/* show logo if do not in hotel list, detail */}
                    </div>
                    <div className="header__logo">
                        <Link className="logo" to={'/'}>
                            <IconLogo />
                        </Link>
                    </div>
                    <div className="header__hotline d-flex">
                        <a href={`tel:${VNTRIP_INFO.hotline}`} className="margin-left-5">
                            <IconPhone />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Header
